import React, { Component } from "react";
import { Table } from "antd";
import { Toast } from "antd-mobile-v2";
import "./index.less";
import { get, headerGet, post, postRaw } from "../../api/service/services";
import { clumnData, exportSaveData } from "./const";
import allUrl from "../../api/allUrl";
import tool from "../../api/tool";
class DetialCompt extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      uploadFile: false,
      tableData: [],
    };
  }
  componentDidMount() {
    let { detailCompt } = this.props.location.state;
    this.getDetailedData(detailCompt);
  }
  clumnRender = () => {
    return [
      ...clumnData,
      {
        title: "文件",
        dataIndex: "files",
        key: "files",
        render: (text, record, index) => {
          return record.files.length > 0
            ? record.files.map((item, index) => {
                return (
                  <a
                    key={index}
                    onClick={() => {
                      this.uploadFilent(
                        item.fileName,
                        item.businessCode,
                        item.id
                      );
                    }}
                    style={{ textDecoration: "underline" }}
                  >
                    附件{index + 1}&nbsp;
                  </a>
                );
              })
            : null;
        },
      },
    ];
  };
  uploadFilent = (fileName, code, id) => {
    get(allUrl.register.uploadFilen, {
      ossCode: "pet-neiwang",
      businessCode: code,
      ids: id,
    }).then((res) => {
      exportSaveData(res, fileName);
      if (res.success === true && res.code == 200) {
      }
    });
  };
  // 投诉详情
  getDetailedData = (id) => {
    postRaw(
      allUrl.register.getDetailedData,
      { id: id },
      {
        "Content-Type": "application/x-www-form-urlencoded",
      }
    )
      .then((res) => {
        if (res.success === true && res.code == 200) {
          let newData = (res.data && res.data) || {};
          this.setState({
            data: newData,
            tableData:
              newData && newData.tonlineBlfs ? newData.tonlineBlfs : [],
          });
        } else {
          Toast.fail(res.msg, 1);
        }
      })
      .catch((error) => {
        Toast.fail("获取详情数据失败", 1);
      });
  };
 orgNameData = (DetailedData) => {
    let str = "";
    if (DetailedData.pcComplaintDetail) {
      if (DetailedData.pcComplaintDetail.complaintParentOrgName != "") {
        str = DetailedData.pcComplaintDetail.complaintParentOrgName;
      } else {
        str = DetailedData.pcComplaintDetail.complaintOrgName;
      }
    }
    return str;
  };
  render() {
    const { data, tableData } = this.state;
    return (
      <div className="detail-cont">
        <div className="detail-text">
          涉及单位：
          {this.orgNameData(data)}
        </div>
        <div className="sups-text">
          主要观点：
          <br />
          <div className="dia-text">
            {data.pcComplaintDetail ? data.pcComplaintDetail.mainAppeal : ""}
          </div>
        </div>
        <div className="sups-text">
          具体建议：
          <br />
          <div className="dia-text">
            {data.pcComplaintDetail
              ? `${data.pcComplaintDetail.complaintReason}`
              : ""}
          </div>
        </div>
        <div className="detail-text">本次办理方式</div>
        <div className="table-cont">
          <div className="table-cont-wrap">
            <Table
              columns={this.clumnRender()}
              dataSource={tableData}
              loading={this.state.uploadFile}
              size="small"
            />
          </div>
        </div>
      </div>
    );
  }
}
export default DetialCompt;
